"use client";
import React, { useState, useRef, useEffect } from "react";
import styles from "./HistoryPage.module.css"
import dynamic from 'next/dynamic';
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: true });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: true });
const SideBar = dynamic(() => import('@/Component/SideBar'), { ssr: true });
const LanguageSelector = dynamic(() => import('@/Component/LanguageSelector'), { ssr: true });
import logo from "@/assets/logo/BePex_Logo.webp";
import { accordion, OnOpenUrl,OnPreFetchUrl } from "@/Component/accordion";
import { useTranslation } from "react-i18next";
import trophy from "@/assets/Icon/Trophy_Icon.png"

import { motion } from "framer-motion";
import { useRouter } from 'next/navigation'; 
import Image from "next/image";
const HistoryData = [
    {
        year: 2021,
        content: [
            { month: "01", imgURL: null },
            { month: "01", imgURL: null },
            { month: "01", imgURL: null },
            { month: "02", imgURL: null },
            { month: "05", imgURL: "2021_PlayX4.png" },
            { month: "06", imgURL: null }
        ],
        rewardCount: 1
    },
    {
        year: 2022,
        content: [
            { month: "05", imgURL: "2022_PlayX4.JPG" },
            { month: "05", imgURL: null },
            { month: "07", imgURL: null },
            { month: "08", imgURL: null },
            { month: "08", imgURL: "2022_BIC.JPG" },
            { month: "09", imgURL: "2022_TGS.png" },
            { month: "09", imgURL: null },
            { month: "12", imgURL: "2022_Burning_Beaver.JPG" }
        ],
        rewardCount: 7
    },
    {
        year: 2023,
        content: [
            { month: "03", imgURL: null },
            { month: "09", imgURL: "2023_TGS.png" },
            { month: "12", imgURL: null },
            { month: "12", imgURL: "2023_Burning_Beaver.JPG" }
        ],
        rewardCount: 0
    },
    {
        year: 2024,
        content: [
            { month: "12", imgURL: null },
            { month: "12", imgURL:null}
        ],
        rewardCount: 0
    },
    {
        year: 2025,
        content: [
            { month: "4", imgURL: null },
            { month: "4", imgURL:null},
            { month: "7", imgURL:null},
            { month: "8", imgURL:null},
            { month: "9", imgURL:null},
            { month: "11", imgURL:null},
        ],
        rewardCount: 1
    }
]
const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.15,
            duration: 0.6,
        },
    }),
};

const AnimatedYear = React.forwardRef(({ year, direction, isColliderEnter }, ref) =>{


    const yearStr = String(year);
    const staticPart = yearStr.slice(0, -1);
    const dynamicPart = yearStr.slice(-1);
    return (
        <span className={`${styles.history__year__text} ${isColliderEnter ? styles.blur : ""}`} >
            <span ref = {ref}>
                {staticPart}
            </span>
            <motion.span
                key={`${dynamicPart}_${direction}`}
                initial={{ y: direction * 40, opacity: 0 }}
                animate={{ y: 0, opacity: 1}}
                transition={{ duration: 0.2 }}
            >
                {dynamicPart}
            </motion.span>
        </span>);
});

const HistoryPage = () => {

    const [isHovered, setIsHovered] = useState(false);
    const { t } = useTranslation();
    const [isSideBarOpen, setIsSideBarOpen] = useState(false);
 
    const itemRefs = useRef([]);
    const prevYearRef = useRef(null);
    const [yearState, setYearState] = useState({ year: null, direction: 1 });
    const [pageIndex, setPageIndex] = useState(1);
    const [isColliderEnter, setColliderEnter] = useState(false);
    const yearRef = useRef(null);
    const router = useRouter();
const [isVisible, setIsVisible] = useState(true); // ✅ 스크롤 방향 감지용
    const lastScrollY = useRef(0); // 마지막 스크롤 위치 저장
const handleHover = (isHover) => {
        setIsHovered(isHover);
    }
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
                // 스크롤 내림
                setIsVisible(false);
            } else {
                // 스크롤 올림
                setIsVisible(true);
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    useEffect(() => {
        const checkCollision = () => {
          if (!yearRef.current || !itemRefs.current) return;
      
          const yearRect = yearRef.current.getBoundingClientRect();
      
          // 현재 표시 중인 연도의 활동 내용 위치
          const currentIndex = HistoryData.findIndex((d) => d.year === yearState.year);
          const contentRect = itemRefs.current[currentIndex]?.getBoundingClientRect();
      
          if (!contentRect) return;
      
          // 범위 조건 조절 가능 (예: 중심값이 겹치면 true)
          const isIntersecting =
            yearRect.bottom >= contentRect.top && yearRect.top <= contentRect.bottom;
      
          setColliderEnter(isIntersecting);
        };
      
        window.addEventListener("scroll", checkCollision);
        window.addEventListener("resize", checkCollision);
        checkCollision(); // mount 시 초기 실행
      
        return () => {
          window.removeEventListener("scroll", checkCollision);
          window.removeEventListener("resize", checkCollision);
        };
      }, [yearState.year]);
    useEffect(() => {
        if (!yearState.year && HistoryData.length > 0) {
            const firstYear = HistoryData[0].year;
            setYearState({ year: firstYear, direction: 1 });
            setPageIndex(1);
            prevYearRef.current = firstYear;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const year = Number(entry.target.getAttribute("data-year"));
                        const dir = year > prevYearRef.current ? 1 : -1;
                        setYearState({ year, direction: dir });
                        setPageIndex(HistoryData.findIndex((item) => item.year === year) + 1);
                        prevYearRef.current = year;
                        setColliderEnter(true);
                    }
                });
            },
            {
                rootMargin: "-50% 0px -40% 0px",
            }
        );

        itemRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        accordion.map((item,index) => {
            item.content.map((content,index) => {
                OnPreFetchUrl({content : content, navigate : router});
            });
        })
    }, []);

    return (
        <div className={styles.page}>

            <div className={`${styles.header__wrap} ${isHovered ? styles.open : ""} ${!isVisible ? styles.hidden : ""}`}>
                <div className={styles.header__inner}>

                    <header className={styles.header}>
                        <div className={styles.logo} onClick={() => OnOpenUrl({content : {url : ""},navigate : router})}>
                            <Image src={logo} className={`${styles.logo__image} ${isHovered ? styles.open : ""}`} alt="logo"/>
                        </div>


                        <div className={styles.nav} onMouseEnter={() => handleHover(true)}
                            onMouseLeave={() => handleHover(false)}>
                            {accordion.map((item, index) => (
                                <div className={styles.nav__button} key={index}>
                                    <div className={styles.nav__title}>
                                        <span className={`${styles.nav__text}`}>
                                            {t(item.nameKey)}
                                        </span>
                                    </div>
                                    <div className={styles.nav__detail}>
                                        <div className={styles.nav__depth2}>
                                            {item.content.map((content, key) => (
                                                <span key={key} className={styles.nav__depth__text} onClick={() => { OnOpenUrl({content : content, navigate : router}) }}>
                                                    {t(content.nameKey)}
                                                    <span className={styles.activeLine}></span>
                                                </span>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>



                    </header>

                    <div className={styles.header__line}>

                    </div>

                    {<SideBar isPanelOpen={isSideBarOpen} onPanelOpen={setIsSideBarOpen}></SideBar>}

                    <div className={styles["side-bar"]}>
                        <LanguageSelector isHover={true}></LanguageSelector>

                        <div className={`${styles["side-bar__close__btn"]} ${isSideBarOpen ? styles.open : ""}`} onClick={() => setIsSideBarOpen(!isSideBarOpen)}>
                            <span></span>
                            <span></span>
                            <span></span>
                            {/* <img src={isClose ?  closeBtn : listBtn} className={`${styles["side-bar__close__btn__image"]}`} >
                        </img> */}
                        </div>

                    </div>

                </div>
            </div>
            <div className={styles.title}>
            <TitleText 
                bottomTextInfo={{
                    textKey: "History.BottomDescription",
                    color : "var(--Gray-700, #4F4F4F)"

                }}
                topTextInfo={{textKey : "History.TopDescription",color:"var(--Gray-700, #4F4F4F)"}}
                titleTextInfo={{textKey : "History.Title",
                    color:"var(--Gray-950, #111)"
                }}
                scrollicon={{filter:"invert(1)"
                }}>
                </TitleText>
            {/*연혁 페이지*/}
            </div>
            <div className={styles.container}>

                

                <div className={styles.history__content}>
                    {/*프로그레스바 UI*/}
                    <div className={styles.progress__container}>
                        <div className={styles.progress}>
                            <div className={styles.scroll}>
                                <div className={styles.total__scroll}>{/*전체 스크롤바*/}
                                    <div className={styles.active__scroll} style={{
                                        top: `${(100 / HistoryData.length) * (pageIndex - 1)}%`,
                                        height: `${(100 / HistoryData.length)}%`
                                    }}>

                                    </div>
                                </div>

                            </div>
                            <div className={styles.scroll__page}>{/*페이지 번호*/}
                                <span className={styles.scroll__page__text}>
                                    {pageIndex}
                                </span>
                                <span className={styles.scroll__page__list__text}>
                                    /{HistoryData.length}
                                </span>
                            </div>
                        </div>
                    </div>
                    {/*연도 연혁*/}
                    <div className={styles.Year}>
                        {/*연도*/}
                        <AnimatedYear year={yearState.year} direction={yearState.direction} isColliderEnter={isColliderEnter} ref={yearRef}></AnimatedYear>
                        {/*연혁*/}
                        <div className={styles.content__year__body}>
                            {/*해당 연도 내용 랜더링 */}
                            {HistoryData.map((item, index) => (
                                <motion.div
                                    ref={(el) => (itemRefs.current[index] = el)}
                                    key={`history_${index}`}
                                    data-year={item.year}
                                    className={styles.history__year}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4, delay: index * 0.05 }}
                                >
                                    <div className={styles.history__list}>
                                        {/*개별 내용*/}
                                        {item.content.map((content, index) => (
                                            <div key={`content_${index}`}
                                                className={styles.history__list__content}

                                            >
                                                <motion.div
                                                    key={`content_${index}`}
                                                    className={styles.history__list__ul}
                                                    custom={`content_${index}`}
                                                    variants={itemVariants}
                                                >
                                                    <span className={styles.history__list__ul__month}>
                                                        {content.month}
                                                    </span>
                                                    <span className={styles.history__list__ul__text}>
                                                        {t(`History.${item.year}.${index + 1}`)}
                                                    </span>
                                                </motion.div>
                                            </div>
                                        ))}

                                        {Array.from({ length: item.rewardCount }).map((_, index) => (
                                            <motion.div
                                                key={`reward_${index}`}
                                                className={styles.history__list__ul}
                                                custom={`reward_${index}`}
                                                variants={itemVariants}
                                            >
                                                <Image src={trophy} className={styles.trophy__image} alt="trophy"/>
                                                <span className={styles.history__list__ul__text}>
                                                    {t(`History.${item.year}.reward.${index + 1}`)}
                                                </span>
                                            </motion.div >
                                        ))}
                                    </div>
                                </motion.div>
                            ))}
                        </div></div>

                </div>
            </div>
            <Footer></Footer>
        </div>
    )
}

export default HistoryPage;